import { ICharacterState } from '../../interfaces/ICharacterState';
import { Character } from '../Character';
import { NpcStateBase } from './NpcStateBase';
import { CharacterAnimation } from '../../enums/CharacterAnimation';
import { PanicAudio } from './audio/PanicAudio';

export class PanicRun extends NpcStateBase implements ICharacterState {
    constructor(character: Character) {
        super(character);
        this.character.simulation.velocitySimulator.damping = 0.6;
        this.character.simulation.velocitySimulator.mass = 10;
        this.character.simulation.rotationSimulator.damping = 0.8;
        this.character.simulation.rotationSimulator.mass = 50;
        this.character.simulation.setArcadeVelocityTarget(0.8);
        this.playAnimation(CharacterAnimation.SlowRun, 0.2, false, false);

        if (character.world?.audioManager) {
            new PanicAudio(character.world.audioManager, character).play();
        }
    }

    public update(timeStep: number): void {
        super.update(timeStep);
    }

    public onInputChange(): void {
        super.onInputChange();
    }
}
